/**
 * Creates a blank/minimal template request for initial preview loads
 *
 * **When it's used:**
 * - Template selection modal: When user first selects a template, we need a minimal
 *   request to generate an initial preview before they've filled in any data
 * - The request includes only:
 *   - template_type (required by API)
 *   - company_name (required by API)
 *   - Empty color and font objects (required by API, even if empty)
 *
 * **Why it exists:**
 * - The API requires color and font sections even if empty
 * - We can't use buildTemplateRequestFromSchema yet because there's no state data
 * - This provides a minimal valid request structure for initial preview generation
 *
 * @param templateType - Template type (default: 'generic')
 * @param companyName - Company/salon name
 * @returns Minimal API request payload with required structure
 */
export const buildBlankTemplateRequest = (
  templateType = "generic",
  companyName = "",
): any => {
  return {
    template_type: templateType,
    company_name: companyName,
    color: {
      primary_color: "",
      secondary_color: "",
    },
    font: {
      primary_font: "",
      secondary_font: "",
    },
  };
};
